var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectronics = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_electronics"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector (Stroke)",
  fillRule: "evenodd",
  d: "M3 5a2.5 2.5 0 0 1 2.5-2.5h13A2.5 2.5 0 0 1 21 5v8.882l.318.635.01.02 1.408 2.817A2.5 2.5 0 0 1 23 18.472v1.025a2 2 0 0 1-1.993 2l-.705.003H3.697l-.711-.005a2 2 0 0 1-1.986-2v-1.023c0-.388.09-.77.264-1.118l1.408-2.816.011-.023.317-.633zm.434 10.25-1.276 2.551a1.5 1.5 0 0 0-.158.671v1.023a1 1 0 0 0 .993 1l.707.005h16.6l.703-.003a1 1 0 0 0 .997-1v-1.025c0-.233-.054-.462-.158-.67l-1.276-2.552zm16.632-1H3.934l.013-.026A.5.5 0 0 0 4 14V5a1.5 1.5 0 0 1 1.5-1.5h13A1.5 1.5 0 0 1 20 5v9a.5.5 0 0 0 .053.224zm-8.42-8.609a.5.5 0 0 1 .708 0l.005.005a.5.5 0 0 1 0 .708l-.005.005a.5.5 0 0 1-.708 0l-.005-.005a.5.5 0 0 1 0-.708zM9.221 18a.5.5 0 0 1 .5-.5h4.558a.5.5 0 1 1 0 1H9.721a.5.5 0 0 1-.5-.5",
  clipRule: "evenodd"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectronics);
export default ForwardRef;